<template>
  <section class="chain-wrapper main-container search text-center pt-10 pb-20 px-5 md:px-10 mx-auto">
    <div class="text-left">
      <ChainComponent />
    </div>
  </section>
</template>

<script>
import ChainComponent from '@/components/common/ChainComponent.vue';

export default {
  name: 'ChainWrapper',
  components: {
    ChainComponent,
  },
};
</script>

<style scoped>
.chain-wrapper {
  max-width: 90vw;
  min-height: calc(100vh - 270px);
}
</style>